import React from 'react'
import { FaExclamationCircle } from 'react-icons/fa'
import { Box, Flex, Image, Text } from 'theme-ui'
import useCurrentUserStore from '../../../stores/currentUser'
import useIdentifierStore from '../../../stores/identifier'
import { logo } from '../Static'

export default function Header() {
  const currentUserId = useCurrentUserStore((s) => s.currentUser?.data?.email)
  const { identifierId, identifierPassword } = useIdentifierStore()

  return (
    <>
      <Flex sx={{ gap: 2, alignItems: 'center', mb: 3 }}>
        <Image src={logo} alt="Report" sx={{ display: 'inline' }} width={50} />
        <Text
          as="h1"
          sx={{ fontSize: 30, textTransform: 'uppercase', fontWeight: 400 }}
        >
          Laporan Pengaduan
        </Text>
      </Flex>

      {currentUserId === identifierId && (
        <Flex sx={{ justifyContent: 'center' }}>
          <Flex
            backgroundColor="highlight"
            p="3"
            mb="3"
            sx={{ alignItems: 'center', width: '700px' }}
          >
            <Box
              as={FaExclamationCircle}
              color="error"
              sx={{ fontSize: '6' }}
              mr="3"
            />
            <Box>
              <Box>
                <Text as="h2">Perhatian Catat akun Anda terlebih dahulu</Text>
              </Box>
              <Box sx={{ fontSize: 2 }}>Nomor: {currentUserId}</Box>
              <Box>Kata Sandi: {identifierPassword}</Box>
              <Box>
                Informasi ini akan hilang jika anda berpindah dari halaman ini
              </Box>
            </Box>
          </Flex>
        </Flex>
      )}
    </>
  )
}
